import React, { useEffect, useState } from "react";
import { FaAngleUp, FaEye, FaSearch, FaUserPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
// import Header from "../../Components/HeaderAdmin/Header";
import CustomSelect from "./SelectBar";
import CustomSelect2 from "./SelectBar2";
import CustomSelectloactor from "./CustomSelectloactor";
import {
  getcountries,
  getstateslocator,
  getcitieslocator,
  searchfitters,
} from "../../Api/iron";
import { Accordion, Form } from "react-bootstrap";
import Loader2 from "../DashboardComponents/Loader/Loader2";
import Pagination from "./Pagination";
import Header from "../../Components/Header/Header";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { addStaff } from "../../Api/staff";
import { API_URL } from "../../Api/config";
import { getcountriesforfitter, getstates, getcities, } from '../../Api/iron'
import RemoateFitting from "../../Components/RemoateFitting/RemoateFitting";
import { getCurrentUser } from "../../Api/auth";
import { use } from "react";

function FitterLocator() {
  const [isLoading, setIsLoading] = useState(false);

  const initCustomerClub = {
    country: {
      label: "United States",
      value: "681354b5a47387f741679d71",
      icon: "/country-icons/united states.svg",
    },
    state: {
      label: "State: All",
      value: null,
      icon: "1",
    },
    city: {
      label: "City: All",
      value: null,
      icon: "1",
    },
  };

  const [dropdownStatusOptions, setdropdownStatusOptions] = useState([
    {
      label: "All",
      icon: "",
      value: null,
    },
  ]);

  const [dropdownStatusOptionssecond, setDropdownStatusOptionssecond] = useState([
    {
      label: "All",
      icon: "0",
      value: null,
    },
  ]);

  const [dropdownStatusOptionsThird, setdropdownStatusOptionsThird] = useState([
    {
      label: "All",
      icon: "0",
      value: "all",
    },
  ]);

  const [dataNull, setDataNull] = useState(null);
  const [apicall, setApicall] = useState(false);
  const [errors, setErrors] = useState([]);
  const [validated, setValidated] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  })

  const [countryKeyword, setCountryKeyword] = useState(
    initCustomerClub.country
  );

  const [stateKeyword, setstateKeyword] = useState(initCustomerClub.state);
  const [cityKeyword, setCityKeyword] = useState(initCustomerClub.city);
  const [filteredData, setFilteredData] = useState([]);
  const [OrderData, setOrderData] = useState([]);
  const [keyword, setKeyword] = useState("");

  const [countryfiltervalue, setcountryfiltervalue] = useState();
  const [statefiltervalue, setstatefiltervalue] = useState(0);
  const [cityfiltervalue, setcityfiltervalue] = useState(0);

  const [currentcityjson, setCurrentCityJson] = useState(null);
  const [currentcity, setCurrentCity] = useState(null);
  const [closestlocator, setclosestlocator] = useState(false);

  const [searchtext, setSearchtext] = useState('');

  useEffect(() => {
    getfitterdatafunc();
    getcountydata();
    getstatedata('681354b5a47387f741679d71')
    getallcountry();
  }, []);

  const [scrollPosition, setScrollPosition] = useState(0);


  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(500); // or whatever you want as default
  const [totalPages, setTotalPages] = useState(1); // set from API response


  const getfitterdatafunc = (countryfiltervalue = '681354b5a47387f741679d71', statefiltervalue, cityfiltervalue, pageNumber = 1, pageSize = 500, currentcity, closestlocator, searchtext) => {
    setScrollPosition(window.scrollY);
    //setApicall(true);
    // //setIsLoading(true);

    const data = {
      pageNumber,
      pageSize,
      countryfiltervalue,
      statefiltervalue,
      cityfiltervalue,
      currentcity,
      closestlocator,
      searchtext
    };

    searchfitters(data)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
        } else {
          const data = response.data.data;
          setFilteredData(data.items);
          // setOrderData(data.items);
          setTotalPages(data.totalPages);
          setDataNull(!null);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
       // setApicall(false);
        // setValidated(true);
        // //setIsLoading(false); 
      });
  };



  const selectedcountry = (option) => {

    setCountryKeyword(option);
    setcountryfiltervalue(option.value);
    setstatefiltervalue(0);
    setcityfiltervalue(0);
    setstateKeyword(initCustomerClub.state);
    setCityKeyword(initCustomerClub.city);
    setDropdownStatusOptionssecond([
      {
        label: "All",
        icon: "0",
        value: "all",
      },
    ]);
    setdropdownStatusOptionsThird([
      {
        label: "All",
        icon: "0",
        value: "all",
      },
    ]);
    getfitterdatafunc(option.value, 0, 0, 1, 500);
    getstatedata(option.value);
  };

  const selectedstate = (option) => {
    setstateKeyword(option);
    setstatefiltervalue(option.value);
    getfitterdatafunc(countryfiltervalue, option.value, cityfiltervalue, 1, 500);
    getcitydata(option.value);
  };

  const selectedcity = (option) => {
    setCityKeyword(option);
    getfitterdatafunc(
      countryfiltervalue,
      statefiltervalue,
      option.value,
      1,
      500
    );
    setcityfiltervalue(option.value);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(true);
  };

  const [loaderhandle, setLoaderhandle] = useState(false);

  useEffect(() => {
    // //setIsLoading(loaderhandle);
    getfitterdatafunc();
    setIsPopupOpen(false);
  }, [loaderhandle]);

  const getcountydata = () => {
    //setApicall(true);
    //setIsLoading(true);

    getcountries()
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
        } else {
          const data = response.data.data;

          const countryOptions = data.map((country) => ({
            label: country.name,
            icon: `/country-icons/${country.name
              .toLowerCase()
              .replace(/\s+/g, " ")}.svg`,
            value: country._id,
          }));

          setdropdownStatusOptions([
            {
              label: "All",
              icon: "/country-icons/all.svg",
              value: null,
            },
            ...countryOptions,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        //setApicall(false);
        //setIsLoading(false);
      });
  };

  const getstatedata = (country_id) => {
    //setApicall(true);
    // //setIsLoading(true);

    const data = {
      country_id: country_id,
    };

    getstateslocator(data)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
        } else {
          const data = response.data.data;

          const StateOptions = data.map((country) => ({
            label: country.name,
            icon: "",
            value: country._id,
          }));

          setDropdownStatusOptionssecond([
            {
              label: "All",
              icon: "0",
              value: null,
            },
            ...StateOptions,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        //setApicall(false);
        // //setIsLoading(false);
      });
  };

  const getcitydata = (state_id) => {
    //setApicall(true);
    //setIsLoading(true);

    const data = {
      state_id: state_id,
    };

    getcitieslocator(data)
      .then((response) => {
        if (!response.data.status) {
          setErrors(response.data.error);
        } else {
          const data = response.data.data;

          const cityOptions = data.map((country) => ({
            label: country.name,
            icon: "",
            value: country._id,
          }));

          setdropdownStatusOptionsThird([
            {
              label: "All",
              icon: "",
              value: null,
            },
            ...cityOptions,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        //setApicall(false);
        //setIsLoading(false);
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getfitterdatafunc(
      countryfiltervalue,
      statefiltervalue,
      cityfiltervalue,
      page,
      pageSize
    );
  };

  const handlefilterdata = () => {
    setCurrentPage(1);
    setclosestlocator(true);
    setcountryfiltervalue(0);
    setstatefiltervalue(0);
    setcityfiltervalue(0);
    setCountryKeyword(initCustomerClub.country);
    setstateKeyword(initCustomerClub.state);
    setCityKeyword(initCustomerClub.city);
    getfitterdatafunc(0, 0, 0, 1, 500, currentcity, true);
  };


  useEffect(() => {
    if (currentcityjson) {
      const city = getCityName(currentcityjson);
      setCurrentCity(city);
    }
  }, [currentcityjson]);

  function getCityName(locationData) {
    for (let i = 0; i < locationData.length; i++) {
      const components = locationData[i].address_components;
      for (let j = 0; j < components.length; j++) {
        if (components[j].types.includes("locality")) {
          return components[j].long_name;
        }
      }
    }
    return "City not found";
  }

  const handleBlur = (value) => {
    setSearchtext(value);
    const lowerQuery = value.toLowerCase();
    const result = OrderData.filter(user =>
      (user.business_name && user.business_name.toLowerCase().includes(lowerQuery)) ||
      (user.firstname && user.firstname.toLowerCase().includes(lowerQuery)) ||
      (user.lastname && user.lastname.toLowerCase().includes(lowerQuery)) ||
      (user.email && user.email.toLowerCase().includes(lowerQuery))
    );

    setFilteredData(result);
    // Call API
    // setFilteredData
    // getfitterdatafunc(
    //   countryfiltervalue,
    //   statefiltervalue,
    //   cityfiltervalue,
    //   1, // page number
    //   10, // page size
    //   currentcity,
    //   closestlocator,
    //   searchtext
    // );
  };

  const [showfitter, setShowfitter] = useState(false);
  const handleClosefitter = () => setShowfitter(false);
  const handleShowfitter = () => setShowfitter(true);

  const [email, setEmail] = React.useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [phone, setPhone] = useState("");
  const [website, setWebsite] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");

  const [serverSideError, setServerSideError] = useState(null);
  // const [apiCall, //setApicall] = useState(false);

  //new code
  const [country_id, setCountry_id] = useState('');
  const [state_id, setState_id] = useState('');
  const [city_id, setCity_id] = useState('');
  const [zipcode, setzipcode] = useState('');
  const [bio, setbio] = useState('');


  const [countrylist, setCountrylist] = useState([]);
  const [statelist, setStatelist] = useState([]);
  const [citylist, setCitylist] = useState([]);

  const [stateLoading, setStateLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);


  const handleSubmit = (event) => {
    //setApicall(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      //setApicall(false);
    } else {
      event.preventDefault();

      const data = {
        firstname: firstName,
        lastname: lastName,
        business_name: businessName,
        phone: phone,
        email: email,
        website_url: website,
        shipping_address: shippingAddress,
        role_id: 9,
        password: "12345678",
        confirmPassword: "12345678",
        country: country_id,
        state: state_id,
        city: city_id,
        zip: zipcode,
        bio: bio,
      };

      addStaff(data).then((res) => {
        console.log(res);
        if (!res.data.status) {
          console.log("res.data.error", res.data.error);
          setServerSideError(res.data.error);
        } else {
          handleClosefitter();
          setFirstName("");
          setLastName("");
          setBusinessName("");
          setPhone("");
          setEmail("");
          setWebsite("");
          setShippingAddress("");
          setServerSideError(null);
          setValidated(false);
          // window.location.href = "/user-dashboard";
          setCountry_id('');
          setState_id('');
          setCity_id('');
          setzipcode('');
          setbio('');
          setStatelist([]);
          setCitylist([]);
        }
      }).catch((err) => {
        // alert(err);
        console.log(err);
      }).finally(() => {
        //setApicall(false);
        // setValidated(false);
      });
    }


    setValidated(true);
  }

  const [showpopup, setShowPopup] = useState(0);

  const showfunction = () => {
    setShowPopup(showpopup + 1);
  }

  const [loginusercallback, setloginusercallback] = useState(null);

  const getallcountry = () => {
    getcountriesforfitter()
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setCountrylist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getallstatefunc = (country_id) => {
    setStateLoading(true)
    const data = {
      country_id: country_id,
    };
    getstates(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          setStateLoading(false)
          const data = response.data.data;
          setStatelist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getallcityfunc = (state_id) => {
    setCityLoading(true);
    const data = {
      state_id: state_id,
    };
    getcities(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          setCityLoading(false);
          const data = response.data.data;
          setCitylist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const currentUserData = getCurrentUser();
    if (currentUserData && currentUserData.user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
      console.error("Current user data is null or undefined");
    }
  }, []);

  const handleShowFitterlogin = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
    }
    const role_id = user?.role_id;


    if (!role_id) {

      // Redirect based on role
      switch (role_id) {
        case 4:
          window.location.href = "/user-dashboard";
          break;
        case 1:
          window.location.href = "/fitter-dashboard";
          break;
        case 8:
          window.location.href = "/fitter-builder-dashboard";
          break;
        case 7:
          window.location.href = "/builder-dashboard";
          break;
        default:
          window.location.href = "/dashboard";
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <Loader2 />
        </div>
      ) : (
        <>
          <Header loginusercallback={loginusercallback} showremotefittingpopup={(poparg) => setShowPopup(poparg)}  />

          <Modal centered show={showfitter} onHide={handleClosefitter} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
              <div className="close-modal">
                <div className="custom-modal-header">
                  <h3 className="text mb-5">Fitter Application</h3>
                  <button type="button" className="btn-close" onClick={handleClosefitter} aria-label="Close">
                    <IoClose />
                  </button>
                </div>
              </div>
              <div className='modal-long-form'>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <div className="row gap-4">
                    <div className='row pe-0' controlid="validationCustom011">
                      <div className='col-md-6'>
                        <div className='form-group-input'>
                          <input type="text" class="form-control dashboard-input-box-3" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" required />
                          <Form.Control.Feedback type="invalid">
                            Please enter a first name.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className='col-md-6 md-5 pe-0'>
                        <div className='form-group-input'>
                          <input type="text" class="form-control dashboard-input-box-3" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name" required />
                          <Form.Control.Feedback type="invalid">
                            Please enter a last name.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom012">
                      <div className='col-md-12 pe-0'>
                        <div className='form-group-input'>
                          <input type="text" class="form-control dashboard-input-box-3" value={businessName} onChange={(e) => setBusinessName
                            (e.target.value)} placeholder="Business Name" required />
                          <Form.Control.Feedback type="invalid">
                            Please enter a business name
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom013">
                      <div className='col-md-12 pe-0'>
                        <div className='form-group-input'>
                          <input type="text" class="form-control dashboard-input-box-3" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" required />
                          <Form.Control.Feedback type="invalid">
                            Please enter a phone number.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom014">
                      <div className='col-md-12 pe-0'>
                        <div className='form-group-input'>
                          <input type="email" class="form-control dashboard-input-box-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid email address.
                          </Form.Control.Feedback>
                          {serverSideError && Array.isArray(serverSideError) && serverSideError.map((error, index) => (
                            error.field === 'email' ? (
                              <div className="text-danger" key={index}>{error.message}</div>
                            ) : null
                          ))}

                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom015">
                      <div className='col-md-12 pe-0'>
                        <div className='form-group-input'>
                          <input type="text" class="form-control dashboard-input-box-3" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="https://example.com" />
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom016">
                      <div className='col-md-12 pe-0'>
                        <div className='form-group-input'>
                          <textarea type="text" class="form-control dashboard-input-box-3" value={shippingAddress} onChange={(e) => setShippingAddress(e.target.value)} placeholder="Shipping Address" style={{ height: "100px" }} required />
                          <Form.Control.Feedback type="invalid">
                            Please enter a shipping address.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>

                    <div className='row pe-0' controlid="validationCustom016">
                      <div className='col-md-6'>
                        <div className='form-group-input'>
                          <select name="country" value={country_id} onChange={(e) => {
                            setCountry_id(e.target.value);
                            setState_id(0);
                            setCity_id(0);
                            getallstatefunc(
                              e.target.value
                            );
                          }}
                            class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                            aria-label="Default select example"
                            required
                          >
                            <option value={0}>
                              Country
                            </option>
                            {countrylist &&
                              countrylist.map(
                                (item) => (
                                  <option
                                    value={item._id}
                                    key={item._id}
                                  >
                                    {item.name}
                                  </option>
                                )
                              )}
                          </select>
                        </div>
                      </div>
                      <div className='col-md-6 md-5 pe-0'>
                        <div className='form-group-input'>
                          <select name="state" value={state_id} onChange={(e) => {
                            setState_id(e.target.value)
                            getallcityfunc(
                              e.target.value
                            );
                          }}
                            class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                            aria-label="Default select example"
                            required
                          >
                            {stateLoading ? (
                              <option disabled>Loading...</option>
                            ) : (
                              <>
                                <option value={0}>State</option>
                                {statelist &&
                                  statelist.map((item) => (
                                    <option value={item._id} key={item._id}>
                                      {item.name}
                                    </option>
                                  ))}
                              </>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom016">
                      <div className='col-md-6'>
                        <div className='form-group-input'>
                          <select name="city" value={city_id} onChange={(e) => { setCity_id(e.target.value); }}
                            class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required>
                            {cityLoading ? (
                              <option disabled>Loading...</option>
                            ) : (
                              <>
                                <option value={0}>City/Town</option>
                                {citylist &&
                                  citylist.map((item) => (
                                    <option value={item._id} key={item._id}>
                                      {item.name}
                                    </option>
                                  ))}
                              </>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className='col-md-6 md-5 pe-0'>
                        <div className='form-group-input'>
                          <input type="text" class="form-control dashboard-input-box-3" value={zipcode} onChange={(e) => setzipcode(e.target.value)} placeholder="Zip code" required />
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0' controlid="validationCustom016">
                      <div className='col-md-12 pe-0'>
                        <div className='form-group-input'>
                          <textarea type="text" class="form-control dashboard-input-box-3" value={bio} onChange={(e) => setbio(e.target.value)} placeholder="Bio..." style={{ height: "100px" }}  />
                        </div>
                      </div>
                    </div>
                    <div className='row pe-0'>
                      <div className='full-width-btn pe-0'>
                        <>
                          {
                            apicall ? (
                              <button className="btn btn_default text-dark btn_disabled" type="submit" disabled>
                                <span>...Submit Fitter Application</span>
                              </button>
                            ) : (
                              <button className="btn btn_default text-dark btn_disabled" type="submit">
                                <span>Submit Fitter Application</span>
                              </button>
                            )
                          }

                          {/* <button className="btn btn_default text-dark btn_disabled" type="submit">Submit Fitter Application</button> */}
                        </>
                      </div>
                    </div>
                  </div>
                </Form>

              </div>
            </Modal.Body>
          </Modal>


          <section id="hero" className="fitter_locator hero img_bg page-section mt-0">

            {width > 768 ? (
              <div className="iframe-hero">
                <img src="https://foreward.golf/default-images/forewardfitterpagedesktopcover.jpg" />
              </div>
            ) : (
              <div className="iframe-hero">
                <img src="https://foreward.golf/default-images/forewardfitterpagemobilecover.jpg" style={{ height: "-webkit-fill-available" }} />
              </div>
            )}

            <div className="container-xl">
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="hero_content">
                    <h1 className="hide_mobile">
                      Find a certified<br /> fitter near you
                    </h1>
                    <h2 >
                      <span className="hide_mobile">
                        Search below to find a Certified Foreward Fitter near you and <br />
                        experience the same system we use in our own facility.
                      </span>
                    </h2>
                    <h1 className="show_mobile">
                      Our fitters <br /> near you
                    </h1>
                    <h2>
                      <span className="show_mobile">
                        Find a Certified Foreward Fitter below near <br />
                        you and experience the same system we <br />
                        use in our own facility.
                      </span>
                    </h2>
                    <div className="arrow_animation show_mobile bounce pt-3">
                      <i className="bi bi-arrow-down-short"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="hide_mobile_f btn-group-list mt-2" role="group" aria-label="Basic example">
                <button className="btn btn-primary btn_default2" onClick={showfunction}>
                  Book Your Fitting
                </button>
                {/* <button className="btn btn-primary btn_default2" onClick={handleShowfitter}>
                  Become a Fitter
                </button> */}
                {
                  isLoggedIn ? (<button className="btn btn-primary btn_default2" onClick={handleShowFitterlogin}>
                    Go to dashboard
                  </button>) : (
                    <button className="btn btn-primary btn_default2" onClick={handleShowfitter}>
                      Become a Fitter
                    </button>
                  )
                }
              </div>
            </div>
          </section>


          <div className="d-flex build_box_dashboard_sec fitter_locator">
            <div className="main-container">
              <div className="main-page-body-content">
                <div className="main-page-body-content-body">
                  <div className="main-page-body-content-body-container">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-4 col-md-5 col-12 filter_header">
                          <div className="black_bg_box sticky-sec">
                            {/* <h1 className="text-center text-white my-5" style={{ fontSize:"5rem" }}>STAFF FITTERS</h1> */}
                            <div className="d-flex flex-column align-items-center respective gap-3">
                              {/* <style>
                                {`
                                    .border_box_view.fefewfefefe{
                                      background-color: #41464f !important;
                                    }
                                  `}
                              </style>
                              <input
                                className="col-12"
                                style={{
                                  border: "1px solid #404650",
                                  backgroundColor: "#41464f",
                                  height: "60px",
                                  borderRadius: "20px",
                                  padding: "0 1.7rem",
                                  color: "white"
                                }}
                                value={searchtext}
                                placeholder="Search Our Fitters..."
                                onChange={(e) => handleBlur(e.target.value)}
                              /> */}
                              <div className="col-12">
                                <div className="btn-1">
                                  <CustomSelectloactor
                                    options={dropdownStatusOptions}
                                    defaultSelected={countryKeyword}
                                    onSelect={selectedcountry}
                                    hasicon={true}
                                  />
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="dropdown-btn-list filter_dropdown_view">
                                  <div className="btn-1">
                                    <CustomSelectloactor
                                      options={dropdownStatusOptionssecond}
                                      defaultSelected={stateKeyword}
                                      onSelect={selectedstate}
                                      hasicon={false}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 ">
                                <div className="dropdown-btn-list filter_dropdown_view">
                                  <div className="btn-1">
                                    {/* <CustomSelect
                                      options={dropdownStatusOptionsThird}
                                      defaultSelected={cityKeyword}
                                      onSelect={selectedcity}
                                      /> */}

                                    <CustomSelectloactor
                                      options={dropdownStatusOptionsThird}
                                      defaultSelected={cityKeyword}
                                      onSelect={selectedcity}
                                      hasicon={false}
                                    />


                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-7 col-12 dashboard-sec">
                          <>
                            {dataNull === null ? null : (
                              <>
                                {filteredData.length === 0 ? (
                                  <div className="no-data-found">
                                    <div className="no-data-img">
                                      <img
                                        src={require("../../assets/images/logo_text.png")}
                                        alt=""
                                      />
                                    </div>
                                    <div className="no-data-text">
                                      <h3>No data Found</h3>
                                    </div>
                                  </div>
                                ) : (
                                  filteredData &&
                                  filteredData.map((item, i) => {
                                    return (
                                      <div className="black_bg_box">
                                        <div className="black_bg_box_inner">
                                          <div className="left_box_content">
                                            <div className="build_title d-flex">
                                              <div className="boxy-icon">
                                                {item?.profile_image ? (
                                                  <img
                                                    src={API_URL + "images/" + item?.profile_image}
                                                    alt="Profile"
                                                    className="img-fluid"
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      borderRadius: "100%",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (<img
                                                  src={`/default-images/default_user_image.jpg`}
                                                  alt="Profile"
                                                  className="img-fluid"
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                />)}
                                              </div>
                                              <div className="ms-4">
                                                <div className="build_title">
                                                  {item?.firstname +
                                                    " " +
                                                    item?.lastname}
                                                </div>
                                                <div
                                                  className="little_text mt-2"
                                                  style={{ fontWeight: "500" }}
                                                >
                                                  {item?.city_name +
                                                    ", " +
                                                    item?.state_name}
                                                  {/* Los Angeles, California */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="right_box_content">
                                            <div className="list_border_boxs project-list-box phone-hide">
                                              <a
                                                href={`tel:${item?.phone}`}
                                                className="border_box_view"
                                              >
                                                <div className="border_box_view_inner d-flex align-items-center">
                                                  <div className="box_icon">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      enable-background="new 0 0 64 64"
                                                      height="512"
                                                      viewBox="0 0 64 64"
                                                      width="512"
                                                    >
                                                      <g
                                                        id="_x32_7-Phone"
                                                        fill="#99ea24"
                                                      >
                                                        <path d="m52.1478348 42.6777344-6.4785156-4.5263672c-.847168-.5908203-1.8374023-.9023438-2.8642578-.9023438-1.6328125 0-3.1655273.8007813-4.0991211 2.140625l-1.5039063 2.1552734c-2.5205078-1.6904297-5.3330097-4.0507813-8.0141621-6.7314453-2.6806641-2.6806641-5.0405273-5.4931641-6.7304688-8.0136719l2.1542969-1.5039063c1.0981445-.7646484 1.831543-1.9101563 2.0644531-3.2246094.2324219-1.3134766-.0605469-2.640625-.8261719-3.7392578l-4.5253906-6.4785156c-.946289-1.3535155-2.4731444-2.1621092-4.0849609-2.1621092-.5585938 0-1.1064453.0986328-1.6279297.2910156-.5922852.21875-1.144043.4873047-1.6850586.8271484l-.8945313.6298828c-.2236328.1738281-.4316406.3642578-.6308594.5634766-1.0913086 1.0908203-1.8657227 2.4716797-2.3027344 4.1044922-1.8647461 6.9902344 2.7548828 17.5605469 11.4951172 26.3007813 7.3398438 7.3398438 16.1577168 11.8994141 23.0117207 11.9003906h.0004883c1.1738281 0 2.2802734-.1367188 3.2890625-.40625 1.6328125-.4365234 3.0136719-1.2109375 4.1054688-2.3027344.1982422-.1982422.3876953-.40625.5908203-.6689453l.6303711-.8994141c.3081055-.4921875.5761719-1.0439453.7978516-1.640625.762207-2.0605469-.0073242-4.4101562-1.871582-5.7128906z" />
                                                      </g>
                                                    </svg>
                                                  </div>
                                                  <div className="box_text_content m-0">
                                                    <div className="big_text">
                                                      Call
                                                    </div>
                                                  </div>
                                                </div>
                                              </a>
                                              <a
                                                href={`mailto:${item?.email}`}
                                                className="border_box_view"
                                              >
                                                <div className="border_box_view_inner d-flex align-items-center">
                                                  <div className="box_icon">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      id="Layer_1"
                                                      height="512"
                                                      viewBox="0 0 32 32"
                                                      width="512"
                                                      data-name="Layer 1"
                                                    >
                                                      <path
                                                        d="m13.4932 11.5488a1.0116 1.0116 0 0 0 .5346.1322 1.3553 1.3553 0 0 0 .5454-.1712l12.0106-7.008a2.99 2.99 0 0 0 -2.5838-1.5018h-20a2.99 2.99 0 0 0 -2.5837 1.5019z"
                                                        fill="#99ea24"
                                                      />
                                                      <path
                                                        fill="#99ea24"
                                                        d="m27 6.57v6.95a8.7994 8.7994 0 0 0 -3-.52 9.0136 9.0136 0 0 0 -9 9 8.2619 8.2619 0 0 0 .06 1h-11.06a3.0088 3.0088 0 0 1 -3-3v-13.43l11.49 6.71a3.1474 3.1474 0 0 0 3.02 0z"
                                                      />
                                                      <path
                                                        fill="#99ea24"
                                                        d="m24 15a7 7 0 0 0 0 14 1 1 0 0 0 0-2 5 5 0 1 1 5-5v1a1 1 0 0 1 -2 0v-1a3 3 0 1 0 -3 3 2.964 2.964 0 0 0 1.4708-.4014 2.9939 2.9939 0 0 0 5.5292-1.5986v-1a7.0085 7.0085 0 0 0 -7-7zm0 8a1 1 0 1 1 1-1 1.0006 1.0006 0 0 1 -1 1z"
                                                      />
                                                    </svg>
                                                  </div>
                                                  <div className="box_text_content m-0">
                                                    <div className="big_text">
                                                      Email
                                                    </div>
                                                  </div>
                                                </div>
                                              </a>
                                              <style>
                                                {`
                                                  @media (max-width: 1279px) and (min-width: 768px) {
                                                    .uyvuyibuono {
                                                      display: none;
                                                    }
                                                    .ytufytftyfftf {
                                                      display: inline-block;
                                                      // padding: 25px;
                                                    }
                                                    .btn-colr.vbuhyvuvu{
                                                      padding: 25px !important;
                                                    }
                                                  }

                                                  @media only screen and (min-width: 768px) and (max-width: 991px){
                                                    .btn-colr.vbuhyvuvu{
                                                      max-width: 28% !important;
                                                    }
                                                  }

                                                  @media (min-width: 1280px) {
                                                    .uyvuyibuono {
                                                      display: inline-block;
                                                    }
                                                    .ytufytftyfftf {
                                                      display: none;
                                                    }
                                                  }

                                                  @media (max-width: 767px) {
                                                    .uyvuyibuono,
                                                    .ytufytftyfftf {
                                                      display: none;
                                                      }
                                                      }
                                                      
                                                  
                                                `}
                                              </style>
                                              <a href={`/fitter/fitter-profile/${item?.username}`} className="btn-colr vbuhyvuvu">
                                                <span className="uyvuyibuono">View Profile</span>
                                                <FaEye className="ytufytftyfftf" />
                                              </a>
                                            </div>

                                            <div className="list_border_boxs project-list-box phone-show">
                                              <div className="d-flex align-items-center justify-content-between w-100">
                                                <a
                                                  href={`tel:${item?.phone}`}
                                                  className="border_box_view"
                                                >
                                                  <div className="border_box_view_inner d-flex align-items-center">
                                                    <div className="box_icon">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        enable-background="new 0 0 64 64"
                                                        height="512"
                                                        viewBox="0 0 64 64"
                                                        width="512"
                                                      >
                                                        <g
                                                          id="_x32_7-Phone"
                                                          fill="#99ea24"
                                                        >
                                                          <path d="m52.1478348 42.6777344-6.4785156-4.5263672c-.847168-.5908203-1.8374023-.9023438-2.8642578-.9023438-1.6328125 0-3.1655273.8007813-4.0991211 2.140625l-1.5039063 2.1552734c-2.5205078-1.6904297-5.3330097-4.0507813-8.0141621-6.7314453-2.6806641-2.6806641-5.0405273-5.4931641-6.7304688-8.0136719l2.1542969-1.5039063c1.0981445-.7646484 1.831543-1.9101563 2.0644531-3.2246094.2324219-1.3134766-.0605469-2.640625-.8261719-3.7392578l-4.5253906-6.4785156c-.946289-1.3535155-2.4731444-2.1621092-4.0849609-2.1621092-.5585938 0-1.1064453.0986328-1.6279297.2910156-.5922852.21875-1.144043.4873047-1.6850586.8271484l-.8945313.6298828c-.2236328.1738281-.4316406.3642578-.6308594.5634766-1.0913086 1.0908203-1.8657227 2.4716797-2.3027344 4.1044922-1.8647461 6.9902344 2.7548828 17.5605469 11.4951172 26.3007813 7.3398438 7.3398438 16.1577168 11.8994141 23.0117207 11.9003906h.0004883c1.1738281 0 2.2802734-.1367188 3.2890625-.40625 1.6328125-.4365234 3.0136719-1.2109375 4.1054688-2.3027344.1982422-.1982422.3876953-.40625.5908203-.6689453l.6303711-.8994141c.3081055-.4921875.5761719-1.0439453.7978516-1.640625.762207-2.0605469-.0073242-4.4101562-1.871582-5.7128906z" />
                                                        </g>
                                                      </svg>
                                                    </div>
                                                    <div className="box_text_content m-0">
                                                      <div className="big_text">
                                                        Call
                                                      </div>
                                                    </div>
                                                  </div>
                                                </a>
                                                <a
                                                  href={`mailto:${item?.email}`}
                                                  className="border_box_view"
                                                >
                                                  <div className="border_box_view_inner d-flex align-items-center">
                                                    <div className="box_icon">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        id="Layer_1"
                                                        height="512"
                                                        viewBox="0 0 32 32"
                                                        width="512"
                                                        data-name="Layer 1"
                                                      >
                                                        <path
                                                          d="m13.4932 11.5488a1.0116 1.0116 0 0 0 .5346.1322 1.3553 1.3553 0 0 0 .5454-.1712l12.0106-7.008a2.99 2.99 0 0 0 -2.5838-1.5018h-20a2.99 2.99 0 0 0 -2.5837 1.5019z"
                                                          fill="#99ea24"
                                                        />
                                                        <path
                                                          fill="#99ea24"
                                                          d="m27 6.57v6.95a8.7994 8.7994 0 0 0 -3-.52 9.0136 9.0136 0 0 0 -9 9 8.2619 8.2619 0 0 0 .06 1h-11.06a3.0088 3.0088 0 0 1 -3-3v-13.43l11.49 6.71a3.1474 3.1474 0 0 0 3.02 0z"
                                                        />
                                                        <path
                                                          fill="#99ea24"
                                                          d="m24 15a7 7 0 0 0 0 14 1 1 0 0 0 0-2 5 5 0 1 1 5-5v1a1 1 0 0 1 -2 0v-1a3 3 0 1 0 -3 3 2.964 2.964 0 0 0 1.4708-.4014 2.9939 2.9939 0 0 0 5.5292-1.5986v-1a7.0085 7.0085 0 0 0 -7-7zm0 8a1 1 0 1 1 1-1 1.0006 1.0006 0 0 1 -1 1z"
                                                        />
                                                      </svg>
                                                    </div>
                                                    <div className="box_text_content m-0">
                                                      <div className="big_text">
                                                        Email
                                                      </div>
                                                    </div>
                                                  </div>
                                                </a>
                                              </div>
                                              <a
                                                href={`/fitter/fitter-profile/${item?.username}`}
                                                className="btn-colr"
                                              >
                                                View Profile
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </>
                            )}
                          </>
                        </div>
                      </div>


                      {/* <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RemoateFitting setuserlogin={(loginusercallback) => setloginusercallback(loginusercallback)} showpopup={showpopup} setpupfalse={(poparg) => setShowPopup(poparg)} />
          <style>
            {`
                                .big_text.ellipsis {
                                    white-space: nowrap; 
                                    overflow: hidden; 
                                    text-overflow: ellipsis; 
                                    width: 200px;
                                }

                                @media only screen and (min-width: 320px) and (max-width: 480px) {
                                    .border_box_view.little{
                                        padding: 14px 0px 14px 15px;
                                    }

                                    .big_text.ellipsis { 
                                        width: 150px;
                                    }
                                }


                                .fitter_locator.hero{
                                  padding: 270px 0px 270px !important;
                                }
                                .fitter_locator .iframe-hero{
                                  position: absolute;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                                }
                                @media (min-width: 992px) and (max-width: 1129px) {
                                  .fitter_locator .iframe-hero img{
                                    height: 100% !important;
                                    width: auto !important;
                                    margin-left: -20vw;
                                  }
                                }
                                @media (min-width: 768px) and (max-width: 991px) {
                                  .fitter_locator .iframe-hero img{
                                    height: 100% !important;
                                    object-fit: cover !important;
                                  }
                                }
                                @media (min-width: 481px) and (max-width: 768px) {
                                  .fitter_locator .iframe-hero img{
                                    object-fit: cover !important;
                                  }
                                }
                                @media (max-width: 480px) {
                                  .fitter_locator .iframe-hero img{
                                    object-fit: cover !important;
                                  }
                                }
                                                    
                                @media (min-width: 1130px) and (max-width: 1519px) {
                                  .fitter_locator .iframe-hero img{
                                    width: 120% !important;
                                    height: 100% !important;
                                  }
                                }
                                @media (min-width: 1520px) {
                                  .fitter_locator .iframe-hero img{
                                    width: -webkit-fill-available !important;
                                  }
                                }
                                                    







                                .fitter_locator .respective .border_box_view{
                                    border: 4px solid #404650;
                                    height: 5rem;
                                    background-color: #1e2025;
                                    border-radius: 30px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    color: #ffffff !important;
                                    text-decoration: none !important;
                                }

                                .fitter_locator .black_bg_box .build_title{
                                    color: #ffffff !important;
                                }

                                @media only screen and (min-width: 991px) and (max-width: 1030px){
                                  .fitter_locator .black_bg_box .build_title .ms-4 .build_title{
                                    white-space: nowrap; 
                                    overflow: hidden; 
                                    text-overflow: ellipsis; 
                                    width: 100px;
                                  }
                                }

                                @media only screen and (min-width: 1031px){
                                  .fitter_locator .black_bg_box .build_title .ms-4 .build_title{
                                    white-space: nowrap; 
                                    overflow: hidden; 
                                    text-overflow: ellipsis; 
                                    width: 180px;
                                  }
                                }

                                .fitter_locator .respective .custom-select.full-width {
                                  border: solid 2px #41464f; 
                                  border-radius: 20px;
                                }

                                // .fitter_locator .filter_dropdown_view .custom-select{
                                //     border-radius: 30px;
                                // }

                                .fitter_locator .list_border_boxs{
                                    justify-content: end;
                                }


                                .fitter_locator .btn-colr{
                                    height: 4.5rem;
                                    border-radius: 20px;
                                    font-weight: 800 !important;
                                }

                                .fitter_locator .border_box_view_inner.mx-5{
                                    margin: 0 4rem !important;
                                }

                                @media only screen and (min-width: 992px) and (max-width: 1440px) {
                                    .fitter_locator .border_box_view_inner.mx-5{
                                      margin: 0 1.5rem !important;
                                      transition: all 0.5s ease-in-out;
                                    }
                                }

                                @media only screen and (min-width: 768px) and (max-width: 991px){
                                    .fitter_locator .black_bg_box .border_box_view{
                                      // width: auto !important;
                                    }
                                }

                                @media only screen and (min-width: 992px) and (max-width: 1120px) {
                                    .fitter_locator .btn-colr, .fitter_locator .big_text{
                                        font-size: 18px !important;
                                    }
                                }

                                @media only screen and (max-width: 991px){
                                    .fitter_locator .black_bg_box .list_border_boxs{
                                      flex-direction: column;
                                    }
                                }

                                @media screen and (min-width: 991px) and (max-width: 1540px) {
                                    .fitter_locator .black_bg_box .box_text_content{
                                        display: none !important;
                                    } 
                                }

                                @media only screen and (min-width: 992px){
                                    .fitter_locator .black_bg_box_inner {
                                        flex-direction: row;
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                    }
                                }

                                @media only screen and (max-width: 991px){
                                    .fitter_locator .respective .marginnfix{
                                        margin-top: 1rem !important;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 991px){
                                  .fitter_locator .phone-show .w-100{
                                    gap: 1rem;
                                  }
                                }

                                @media only screen and (max-width: 767px){
                                    .fitter_locator .black_bg_box .border_box_view{
                                      width: 100% !important;
                                      height: 72px !important;
                                      justify-content: space-evenly !important;
                                    }
                                }
                                
                                @media only screen and (min-width: 320px) and (max-width: 480px) {
                                    .fitter_locator .black_bg_box .border_box_view {
                                        padding: 0 !important;   
                                    }
                                }
                                @media only screen and (min-width: 481px) and (max-width: 991px) {
                                    .fitter_locator .black_bg_box .border_box_view {
                                        padding: 0 !important;
                                    }
                                }

                                @media only screen and (min-width: 320px) and (max-width: 480px){
                                  .fitter_locator .black_bg_box .border_box_view .border_box_view_inner{
                                    margin-right: 0 !important;
                                  }
                                }

                                @media only screen and (min-width: 991px) and (max-width: 1100px) {
                                  .fitter_locator .black_bg_box .build_title .ms-4 .little_text{
                                      white-space: nowrap;
                                      overflow: hidden;
                                      text-overflow: ellipsis;
                                      width: 100px;
                                  }
                                }

                                @media only screen and (max-width: 991px) {
                                  .fitter_locator .black_bg_box .build_title .ms-4 .build_title{
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    width: 200px;
                                  }
                                }

                                @media only screen and (min-width: 768px) and (max-width: 1279px) {
                                  .fitter_locator .results-accordion .accordion-header .accordion-button {
                                    padding: 0px 14px;
                                  }
                            }

                            

                                .btn-become{
                                  background: #99ea24 !important;
                                  color: #1e2025 !important;
                                  border-radius: 12px;
                                  border: 1px solid #99ea24 !important;
                                  display: flex;
                                  align-items: center;
                                  width: 12rem;
                                  justify-content: center;
                                  padding: 0;
                                  font-size: 1.1rem;
                                  height: 3.5rem;
                                  font-weight: 900 !important;
                                }

                                @media only screen and (min-width: 768px){
                                  .sticky-sec{
                                    position: sticky;
                                    height: fit-content;
                                    top: 10rem;
                                  }
                                }

                                @media only screen and (max-width: 767px){
                                    .btn-become{
                                      display: none !important;
                                    }
                                }

                                .fitter_locator .options-list.custom-options-list {
    max-height: 250px;
    overflow-y: auto;
}

/* Styling the scrollbar */
.filter_dropdown_view .options-list.custom-options-list::-webkit-scrollbar {
    width: 5px;
}

.filter_dropdown_view .options-list.custom-options-list::-webkit-scrollbar-track {
    background-color: transparent;
}

.filter_dropdown_view .options-list.custom-options-list::-webkit-scrollbar-thumb {
    background-color: #99ea24;
    border-radius: 10px;
}

.filter_dropdown_view .options-list.custom-options-list::-webkit-scrollbar-thumb:hover {
    background-color: #99ea24;
}

/* For Firefox */
.filter_dropdown_view .options-list.custom-options-list {
    scrollbar-width: thin;
    scrollbar-color: #99ea24 transparent;
}

.d-flex.build_box_dashboard_sec.fitter_locator {
    background-color: var(--bg_dark) !important;
}

                    .btn-group-list.mt-2 .btn_default2:nth-child(1) {
                        background: #98ea24 !important;
                        font-weight: 700 !important;
                        color: #000000 !important;
                    }

                    .btn-group-list.mt-2 .btn_default2:nth-child(2) {
                        background: #ffffff !important;
                        font-weight: 700 !important;
                        color: #000000 !important;
                    }
                            `}
          </style>
        </>
      )}
    </>
  );
}

export default FitterLocator;
